import { IntlProvider as ReactIntlProvider } from 'react-intl';
import enMessages from './messages/en';
const messages = {
  en: enMessages,
};

export const IntlProvider = ({ children }: { children: React.ReactNode }) => {
  const locale = 'en';
  return (
    <ReactIntlProvider messages={messages[locale]} locale={locale} defaultLocale="en">
      {children}
    </ReactIntlProvider>
  );
};
